export default {
  list: {
    isLoaded: false,
    isLoading: false,
    error: '',
    byUser: false,
    data: {
      matched_rules_map: {},
      results: [],
    },
  },
  show: {
    data: {},
  },
};
